import type { FormDefinition } from './types'

export default {
  sections: {
    'Neuer Coach': {
      fields: [
        { id: 'Neuer Coach.Vorname', control: 'text-or-date' },
        { id: 'Neuer Coach.Nachname', control: 'text-or-date' },
        { id: 'Neuer Coach.E-Mail', control: 'text-or-date' },
      ],
    },
  },
} satisfies FormDefinition
